import { useLocalStorageState } from 'ahooks';
import { LocalStorageKey } from '@/utils/storageKeys';
import { ALLOW_FEATURE_FLAGS } from '@/configs';

type UseFeatureFlagIsEntryVisibleReturns = [
  isFeatureFlagEntryVisible: boolean,
  setIsFeatureFlagEntryVisible: (value: boolean) => void,
];

export const useFeatureFlagIsEntryVisible = (): UseFeatureFlagIsEntryVisibleReturns => {
  const [isEntryVisible, setIsEntryVisible] = useLocalStorageState<boolean | undefined>(
    LocalStorageKey.FeatureFlagEntryVisible,
    {
      defaultValue: undefined,
      listenStorageChange: true,
    }
  );

  const setIsFeatureFlagIsEntryVisible = (value: boolean): void => {
    if (!ALLOW_FEATURE_FLAGS) return;
    setIsEntryVisible(value ? true : undefined);
  };

  return [ALLOW_FEATURE_FLAGS && (isEntryVisible ?? false), setIsFeatureFlagIsEntryVisible];
};
